module.exports = __webpack_public_path__ + "media/images/team-referrals-empty-23ac486b90598d90e7319c8e21406fd7.png";